import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { secondary, warning } = theme.palette;

  return {
    arrowButton: {
      padding: "0 2px 2px 2px"
    },
    upArrow: {
      color: secondary.dark
    },
    downArrow: {
      color: warning.dark
    },
    claimChangeContent: {
      whiteSpace: "nowrap"
    }
  };
});
